import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { useTranslation } from "gatsby-plugin-react-i18next"
import ortadogu1 from "../../assets/img/ortadogu1.png"
import ortadogu2 from "../../assets/img/ortadogu2.png"

export default function OrtadoguProjesi() {
  const { t } = useTranslation()
  return (
    <Layout>
      <SEO title="Ortadoğu Projesi" />
      <div className="projeler-container page">
        <div className="ic-proje">
          <img src={ortadogu1} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("ortadogu-projesi")}
            <br />
            <span>{t("project-sector")}</span>: {t("grup")}
            <br />
            <span>{t("project-subject")}</span>: {t("sanat-projesi")}
            <br />
            <span>{t("project-artwork")}</span>: {t("bilal-akkaya-pr")}
          </div>
          <img src={ortadogu2} alt="" className="proje-icGorsel" />
        </div>
      </div>
    </Layout>
  )
}
